import React, { ReactElement, useEffect, useState } from 'react';

import { SHARE_URL } from '@common/const';
import { css } from '@emotion/react';
import { UseShareDataPropsType, UseShareDataReturn } from '@type/web/share';

import useConfirmModal from '@hook/useConfirmModal';

import ShareModalV3 from '@components/common/ShareModal/ShareModalV3';

/**
 * 이미지가 있는 확인 모달 형태 공유하기
 * @param data 공유할 데이터
 * @param defaultData 공유할 데이터 기본값
 * @returns 공유하기 팝업 컴포넌트, 공유하기 팝업 닫기 함수
 */
export default function useShareDataPopUpV3({
  data,
  defaultData,
  shareMessage = '친구들에게 공유하기!',
}: UseShareDataPropsType): UseShareDataReturn {
  const { ConfirmModal, onShowConfirmModal } = useConfirmModal();

  const [shareData, setShareData] = useState({
    type: defaultData?.type || '',
    text: defaultData?.text || '',
    bannerUrl: defaultData?.bannerUrl || '',
    bannerTitle: defaultData?.bannerTitle || '',
    kakao: {
      title: defaultData?.kakao?.title || '',
      description: defaultData?.kakao?.description || '',
      imageUrl: defaultData?.kakao?.imageUrl || '',
      link: defaultData?.kakao?.link || '',
      btn_title: defaultData?.kakao?.btn_title || '',
    },
    facebook: defaultData?.facebook || '',
    url: defaultData?.url || '',
    GA: {
      location: defaultData?.GA?.location || '',
      query: defaultData?.GA?.query || '',
      title: defaultData?.GA?.title || '',
      category: defaultData?.GA?.category || '',
    },
  });

  useEffect(() => {
    if (!data) return;

    setShareData({
      ...shareData,
      text: data.text || shareData.text,
      bannerUrl: data.bannerUrl || '',
      bannerTitle: data.bannerTitle || '',
      kakao: {
        ...shareData.kakao,
        title: data.title || '',
        description: data.description || '',
        imageUrl: data.bannerUrl || '',
        link: `${SHARE_URL}${data.shareUrl}` || '',
      },
      facebook: data.shareUrl ? `${SHARE_URL}${data.shareUrl}` : '',
      url: data.shareUrl ? `${SHARE_URL}${data.shareUrl}` : '',
    });
  }, [...Object.values(data || {})]);

  const SharePopUpComponent = (): ReactElement => (
    <ConfirmModal
      isShowConfirmButton={false}
      style={css`
        padding: 0;
      `}
    >
      <ShareModalV3
        shareData={shareData}
        imgUrl={data?.bannerUrl}
        shareMessage={shareMessage}
      />
    </ConfirmModal>
  );

  return { SharePopUpComponent, onShowPopUp: onShowConfirmModal };
}
